export default __webpack_public_path__ + "static/media/sticker-Y.f839919b.png";